import {TOption} from './TOption'

export const REGARDING_OPTIONS: TOption[] = [
  {value: 'PO001', label: 'penjualan'},
  {value: 'PO002', label: 'Non-penjualan'},
]
